import React from 'react'
import { useParams } from 'react-router'
import { useZone } from '../../hooks/CompanyConfiguration/useZone'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import ZoneView from '../../components/version-4/viewForms/ZoneView'
import { ROUTES } from '../../shared/constants'

function ViewZone() {
  const { zone, getZone } = useZone()
  const params = useParams()

  React.useEffect(() => {

    getZone({ zoneId: params.zoneId })
  }, [params.zoneId])

  return (
    <Layout heading="Zone" heading2="Info" url1={ROUTES.ZONE} none>
      {zone ? (
        <HeaderTabLayout
          heading="Zone"
          content={<ZoneView zone={zone} />}
          view
          url={`/edit-zone/${params.zoneId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewZone
